import { render, staticRenderFns } from "./AccidentsFilterButton.vue?vue&type=template&id=08828766&scoped=true&"
import script from "./AccidentsFilterButton.vue?vue&type=script&lang=js&"
export * from "./AccidentsFilterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08828766",
  null
  
)

export default component.exports